import { render, staticRenderFns } from "./BasketEmpty.vue?vue&type=template&id=74fc813e&"
import script from "./BasketEmpty.vue?vue&type=script&lang=js&"
export * from "./BasketEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports